import { t } from "@/i18n-js/instance";
import { IconButton } from "@circle-react-shared/uikit/HeaderV3/IconButton";

export interface ListFieldItemURLActionsProps {
  onClickDelete: () => void;
}

export const ListFieldItemURLActions = ({
  onClickDelete,
}: ListFieldItemURLActionsProps) => (
  <div className="flex items-center gap-2">
    <IconButton
      name="16-close-v2"
      ariaLabel={t("builder_ui.prop_type.list.delete_link")}
      onClick={onClickDelete}
    />
  </div>
);
